import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useObserver, uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { PreferencesModel } from '../../preferences/PreferencesModel';
import { Root } from '../entities/Root';
import { ComponentMount } from './ComponentMount';
import { Origin } from './Origin';
import { RenderGrid } from './RenderGrid';
import { RenderingContext } from './RenderingContext';

const CenterVisual = styled.div`
    position: absolute;
    left: -5px;
    top: -5px;
    width: 10px;
    height: 10px;
    background: gainsboro;
    border-radius: 50%;
`;

const RenderRoot = ({ id }: { id: string }) => {
    const rootElmt = useResolve(ObjectManager).getMaybe(id, Root);
    if (!rootElmt) return null;
    return <ComponentMount object={rootElmt} />;
};

const RenderWithQuality = React.memo<{ gfxLevel: number }>(({ gfxLevel }) =>
    <Flexer id="renderer" absolute top="0" left="0" right="0" bottom="0" overflow="hidden" background="#F6FAFD">
        <RenderGrid />
        <Origin fixInitialLoadBug>
            {/* <GridVisual /> */}
            <CenterVisual />
            <RenderingContext.Provider value={{ type: 'default', gfxLevel }}>
                <RenderRoot id="root" />
                <RenderRoot id="EdgeRoot" />
            </RenderingContext.Provider>
        </Origin>
    </Flexer>
);

export const HtmlRenderer = () => {
    const { gfxLevel, handwritingMode } = useObserver(useResolve(PreferencesModel));
    const { handwriting } = useObserver(useResolve(ProfileModel));

    // Force re-render when these change
    const key = useMemo(() => uuid(), [handwriting, handwritingMode]);
    return <RenderWithQuality {...{ key, gfxLevel }} />;
};
